import * as React from "react";
import { cn, getInitials } from "@/lib/utils";

const avatarColors = [
  "bg-accent/20 text-accent",
  "bg-sage/20 text-sage",
  "bg-status-info/20 text-status-info",
  "bg-status-warning/20 text-status-warning",
  "bg-rose-gold/20 text-rose-gold",
];

function getColorByName(name: string): string {
  const index = name.charCodeAt(0) % avatarColors.length;
  return avatarColors[index];
}

export interface AvatarProps extends React.HTMLAttributes<HTMLDivElement> {
  src?: string;
  alt?: string;
  name: string;
  size?: "sm" | "md" | "lg";
}

const sizeClasses = {
  sm: "h-8 w-8 text-xs",
  md: "h-10 w-10 text-sm",
  lg: "h-12 w-12 text-base",
};

function Avatar({ className, src, alt, name, size = "md", ...props }: AvatarProps) {
  const initials = getInitials(name);
  const colorClass = getColorByName(name);

  if (src) {
    return (
      <div
        className={cn(
          "relative overflow-hidden rounded-full",
          sizeClasses[size],
          className
        )}
        {...props}
      >
        <img
          src={src}
          alt={alt || name}
          className="h-full w-full object-cover"
        />
      </div>
    );
  }

  return (
    <div
      className={cn(
        "flex items-center justify-center rounded-full font-medium",
        sizeClasses[size],
        colorClass,
        className
      )}
      {...props}
    >
      {initials}
    </div>
  );
}

export { Avatar };
